import { useCallback, useEffect, useState } from "react";

// A yes/no UI choice (e.g. a section collapsed) remembered in localStorage
// across refreshes. If storage is blocked (private mode), it still toggles —
// it just isn't remembered.
function readStored(key, fallback) {
  try {
    const stored = localStorage.getItem(key);
    return stored === null ? fallback : stored === "1";
  } catch {
    return fallback;
  }
}

const useStoredFlag = (key, fallback = false) => {
  const [value, setValue] = useState(() => readStored(key, fallback));

  useEffect(() => {
    try {
      localStorage.setItem(key, value ? "1" : "0");
    } catch {
      // not persisted this time
    }
  }, [key, value]);

  const toggle = useCallback(() => setValue((current) => !current), []);

  return [value, toggle];
};

export default useStoredFlag;
